__turbopack_context__.v({
  "actionButton": "QuestionsLibraryPopup-module__CsxVJG__actionButton",
  "active": "QuestionsLibraryPopup-module__CsxVJG__active",
  "addButton": "QuestionsLibraryPopup-module__CsxVJG__addButton",
  "addQuestionIcon": "QuestionsLibraryPopup-module__CsxVJG__addQuestionIcon",
  "cancelButton": "QuestionsLibraryPopup-module__CsxVJG__cancelButton",
  "categoriesContainer": "QuestionsLibraryPopup-module__CsxVJG__categoriesContainer",
  "categoryButton": "QuestionsLibraryPopup-module__CsxVJG__categoryButton",
  "contentContainer": "QuestionsLibraryPopup-module__CsxVJG__contentContainer",
  "delete": "QuestionsLibraryPopup-module__CsxVJG__delete",
  "deleteButton": "QuestionsLibraryPopup-module__CsxVJG__deleteButton",
  "deleteWarningIcon": "QuestionsLibraryPopup-module__CsxVJG__deleteWarningIcon",
  "dragHandle": "QuestionsLibraryPopup-module__CsxVJG__dragHandle",
  "emptyState": "QuestionsLibraryPopup-module__CsxVJG__emptyState",
  "emptyStateIcon": "QuestionsLibraryPopup-module__CsxVJG__emptyStateIcon",
  "favoriteButton": "QuestionsLibraryPopup-module__CsxVJG__favoriteButton",
  "formContainer": "QuestionsLibraryPopup-module__CsxVJG__formContainer",
  "headerContainer": "QuestionsLibraryPopup-module__CsxVJG__headerContainer",
  "metaSeparator": "QuestionsLibraryPopup-module__CsxVJG__metaSeparator",
  "popupOverlay": "QuestionsLibraryPopup-module__CsxVJG__popupOverlay",
  "questionActions": "QuestionsLibraryPopup-module__CsxVJG__questionActions",
  "questionCard": "QuestionsLibraryPopup-module__CsxVJG__questionCard",
  "questionContent": "QuestionsLibraryPopup-module__CsxVJG__questionContent",
  "questionEditInput": "QuestionsLibraryPopup-module__CsxVJG__questionEditInput",
  "questionHeader": "QuestionsLibraryPopup-module__CsxVJG__questionHeader",
  "questionMeta": "QuestionsLibraryPopup-module__CsxVJG__questionMeta",
  "questionText": "QuestionsLibraryPopup-module__CsxVJG__questionText",
  "questionsGrid": "QuestionsLibraryPopup-module__CsxVJG__questionsGrid",
  "searchContainer": "QuestionsLibraryPopup-module__CsxVJG__searchContainer",
  "searchIcon": "QuestionsLibraryPopup-module__CsxVJG__searchIcon",
  "searchInput": "QuestionsLibraryPopup-module__CsxVJG__searchInput",
  "sidePopup": "QuestionsLibraryPopup-module__CsxVJG__sidePopup",
  "sidePopupOpen": "QuestionsLibraryPopup-module__CsxVJG__sidePopupOpen",
});
